var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 735.16469,
    height: 684.28538,
    viewBox: "0 0 735.16469 684.28538",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      userSelect: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M940.79492,190h7.30066c5.593-42.93854-37.44061-75.54559-86.79895-79.52624A105.83718,105.83718,0,0,1,940.79492,190Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.18768,318.11091q-6.19721-.07561-11.87463-.41815A50.57516,50.57516,0,0,0,827.18768,318.11091Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.32385,213.34773c.95258-56.559,46.02069-102.58771,102.58844-102.58771a125.18083,125.18083,0,0,1,23.38434-.28625,105.52282,105.52282,0,0,0-128.87549,102.874c0,53.63012,1.91907,99.38489,82.89191,104.345C774.289,311.462,734.57587,257.75917,735.32385,213.34773Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.58521,215c-18.54316,31.7226-91.45185,54.98731-101.67292,100.93689a46.80065,46.80065,0,0,1-10.72461,2.174c3.35968.041,6.8255.02771,10.42749-.055,57.61542,0,104.87439-45.66156,105.76715-103.05585Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.19145,290.43711c-13.48355-29.25072-19.3881-60.77515-15.25269-95.31151-.63891-4.01772,1.60067-8.04395,5.00634-9.0002l61.045-17.0549c3.40711-.94712,6.68847,1.53668,7.33507,5.55226l15.25275,95.31151c.63892,4.01772-1.6006,8.044-5.00626,9.00014l-61.045,17.05489C850.11955,296.93642,846.83812,294.45269,846.19145,290.43711Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 864.81216,
    cy: 178.28462,
    rx: 12.43264,
    ry: 10.37768,
    transform: "translate(344.76101 905.26409) rotate(-82.63777)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.47082,243.82723c-13.48356-29.25072-19.38811-60.77515-15.2527-95.31151-.63891-4.01772,1.60067-8.04395,5.00634-9.0002l61.045-17.0549c3.40711-.94712,6.68847,1.53668,7.33507,5.55226l15.25275,95.31151c.63892,4.01772-1.6006,8.044-5.00626,9.00014l-61.045,17.05489C767.39891,250.32654,764.11748,247.84281,763.47082,243.82723Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.09152,
    cy: 131.67474,
    rx: 12.43264,
    ry: 10.37768,
    transform: "translate(318.86597 782.58821) rotate(-82.63777)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 452.63742,
    width: 614.60645,
    height: 2,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.41766,324.49473c-.725-2.53751,9.41132,20.72,7,21-10.98269,1.26-35.31853,6.94-42.96788,10-.34451-.04-.689-.08-1.02331-.13-.82065-.09-1.62109-.22-2.41132-.37-17.81139-3.37-31.28642-18-31.65114-35.66-.02028-.25-.02028-.51-.02028-.76a33.47951,33.47951,0,0,1,.1925-3.65,34.33268,34.33268,0,0,1,.86116-4.91l-.0405-.00995c-7.09213-6.66-4.10329-19.01,4.93409-24.22a32.5508,32.5508,0,0,1,12.78608-4.15,34.279,34.279,0,0,1,3.67778-.2h11.53992a53.63143,53.63143,0,0,1,7.24406-1.05h.02028c23.23178-1.77,41.54974,12.39,39.8375,29.62-.01014.02-.03043.04-.04051.06-.4965.74-.93215,1.44-1.31716,2.11-.37486.63-.68894,1.23-.96245,1.8-2.11753,4.4,3.32552,9.93661-.2837,10.97-4.80026,1.37445,12.62488,46.55-6.37512,46.55C492.65969,374.12241,484.41766,331.49473,482.41766,324.49473Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.007 653.298 370.991 653.171 377.622 594.033 355.51 594.219 356.007 653.298",
    fill: "#ffb6b6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.41749,784.98081a6.70746,6.70746,0,0,1-6.64132,6.75737l-29.78956.24859-5.21507-10.57088-1.91533,10.62485-11.24025.10195,2.83831-37.89483,3.91065-.26017,15.95083-1.09955,5.14613-.34462.09025,10.72188,23.92992,16.231A6.69637,6.69637,0,0,1,636.41749,784.98081Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.41766,731.49473c-5.96-.72-21-2-21-2s-7.1-14.82-5.95-19.43c1.13-4.63,3.95-5.57,1.33-7.99006-6.38-23.57995-5.36-61.87994-5.36-61.87994s-34.34-16.63-69.11-35.88c-33.99-18.83-68.38995-40.16-71.5-50.91a136.94481,136.94481,0,0,1-4.12-23.47c-.51995-5.2-.84-10.3-1.04-14.87-.47-10.46-.28-18.19-.28-18.19l43.33-.72,28.7-.66h3v5l7.54,12.82s13.03,15.15,11.5,16.56c-1.85,1.71-1.29,3.23,5.28,4.47a21.36163,21.36163,0,0,0,5.66.23c10.61-.81,15.05,5.26,15.31,6.59,1.78,9.39,19.63,29.79,36.35,47.2h.01c15.43,16.08,29.89,29.6,29.89,29.6l.82,17.25,3.85,80.65s-7.22-4.04-.77,4.67C627.30767,729.25474,613.37768,732.20469,607.41766,731.49473Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.561 436.107 543.678 422.427 492.655 391.8 483.627 411.987 537.561 436.107",
    fill: "#ffb6b6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.60652,510.22883a6.70747,6.70747,0,0,1,3.38287,8.85017l-12.16411,27.194-11.78222.34591,8.86561,6.16092-4.58237,10.26428-33.281-18.34249,1.38993-3.66455,5.6344-14.963,1.827-4.82322,9.788,4.3774,24.71347-15.011A6.69638,6.69638,0,0,1,811.60652,510.22883Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.73324,510.85508c-.03479.078-.07675.149-.11172.21286-2.78777,5.11668-7.3629,16.95567-7.64805,17.6859a.10891.10891,0,0,0-.01387.04247s-15.09507-.77769-18.95292-3.5455c-3.8651-2.78895,1.9835,1.62042-6.92917-4.21139-4.60912-3.03153-20.3949-7.76456-34.53447-11.63162-13.15489-3.59773-24.87628-6.427-24.87628-6.427s-10.36109,9.43038-25.37255,22.46216l-.007.00712c-13.94293,12.07729-31.91016,27.26405-49.32212,40.86326-37.27819,10.96476-76.6237,20.46519-86.45949,15.1274a136.94528,136.94528,0,0,1-19.59849-13.55409l10.12844-26.54824L506.821,513.2877l28.19549-11.45664,11.0299-4.48491,15.44484-6.26751,83.62039-33.9748,92.60318,32.07508s-6.45011,5.21137,4.04678,2.46246C752.11719,488.93582,746.646,505.36992,743.73324,510.85508Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.41766,356.49473h30l4.72341,10.42578,20.091,8.95193A18.25955,18.25955,0,0,1,516.629,388.64858c7.23437,33.07129-1.9166,39.94254-2.21129,50.84615-1,37-6.15265,44.35981-5.57632,53.49367.17248,2.73358,1.84109,13.54206,7.2087,12.52419s2.47418,3.255,3.74451,4.91622c1.09758,1.43528,6.87018-.46946,3.24664,4.29823s11.8678,17.76769,2.37647,17.76769c-18,0-54,9-68,9s-24.8189,4.151-31,4c-3.7673-.092-2.58943-17.6586-1.08367-32.8717.34094-3.44456,6.95562-3.35479,1.01964-9.74155s1.05143-9.70583,1.064-11.38675c.01338-1.7857,3.36516-6.28408-.81742-13.642s-.327-4.31321-.50869-6.62366c-1.4-17.805-3.40618-40.5074-3.40618-40.5074l-8.8435-24.88973a26.04063,26.04063,0,0,1,14.98236-32.94258l10.37364-4.092Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.11327,347.31424a9.74338,9.74338,0,0,1-14.50321,3.13865l-42.261,23.92571-9.49179-10.06228,50.40182-28.04993a9.72972,9.72972,0,0,1,15.85419,11.04785Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#ffb6b6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.83146,403.79l-.64357,7.70473,84.134-1.08159,83.74648-47.0804-12.24324-18.84418-73.60826,30.94875-52.316,1.06091A29.77646,29.77646,0,0,0,471.83146,403.79Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.26124,
    cy: 215.82239,
    r: 27.32215,
    fill: "#ffb6b6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.3966,311.49473c-.45594.24-.90173.46-1.35767.68-.47615.23-.95237.46-1.42852.67-9.14888,4.15-16.59558,4.61-21.1143-1.35a25.26,25.26,0,0,0-2.077-9.1,14.62658,14.62658,0,0,1-2.41133,9.1h-9.09816c-9.37174,6.22-14.18426,6.87-7.67978,27.29,1.8136,5.69,9.02462,38.8,6.18779,43.71-.82066-.09-9.61228-27.35-10.40251-27.5-17.81139-3.37-31.28642-18-31.65114-35.66.02022-.9.081-1.8.17222-2.68a47.71735,47.71735,0,0,1,3.86014-5.04,30.59344,30.59344,0,0,1,3.1712-13.61,31.30408,31.30408,0,0,1,11.8945-12.94,55.16343,55.16343,0,0,1,9.50345-3.57c.08107-.02.152-.04.233-.06,1.003-.27,2.02632-.52,3.04962-.73a56.09643,56.09643,0,0,1,6.40319-.97c.152-.01.30393-.02.44579-.02a4.82509,4.82509,0,0,1,2.44169.67c.01014,0,.01014.01.02028.01a4.59717,4.59717,0,0,1,1.35767,1.21,4.65,4.65,0,0,1,.99288,2.89h10.1316q.5623,0,1.1246.03a27.16579,27.16579,0,0,1,26.19024,25.54C492.38646,310.54472,492.3966,311.01469,492.3966,311.49473Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 190.63742,
    r: 18,
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.41766,284.49473c.34375,9.93518-8.05888,18-18,18a18,18,0,0,1-18-18c0-9.94113,12.03943-10.044,18-18C436.84972,255.23988,445.95409,271.09634,446.41766,284.49473Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.95239,566.07549c-2.795-41.47321,5.38725-80.48472,28.11105-116.23511a9.1398,9.1398,0,0,1,11.01963-6.7275l87.7833,21.23a9.13964,9.13964,0,0,1,6.72742,11.01957l-28.111,116.23516a9.1396,9.1396,0,0,1-11.0195,6.72747l-87.7833-21.23A9.13985,9.13985,0,0,1,469.95239,566.07549Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.15544,574.88366a9.13965,9.13965,0,0,1-6.72748-11.0195c-2.79509-41.4734,5.38722-80.48485,28.1109-116.23521a9.02174,9.02174,0,0,1,2.27158-4.09835l-1.7274-.41785a9.14,9.14,0,0,0-11.01965,6.72738c-22.72373,35.75044-30.906,74.76181-28.11089,116.2352A9.13961,9.13961,0,0,0,476.68,577.09484l87.7832,21.23017a9.09906,9.09906,0,0,0,8.74807-2.629Z",
    transform: "translate(-232.41766 -107.85731)",
    opacity: 0.2,
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.6351,525.95227l-58.86472-14.06358a3.63129,3.63129,0,0,1,1.68757-7.06379l58.86472,14.06357a3.6313,3.6313,0,0,1-1.68765,7.06375Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.34819,495.61357l-12.95018-3.094a3.63132,3.63132,0,0,1,1.66535-7.06912l.0223.00538,12.95018,3.094a3.6313,3.6313,0,0,1-1.68765,7.06375Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.21584,557.0064l-58.86472-14.06358a3.63129,3.63129,0,0,1,1.68765-7.06374l58.86471,14.06357a3.63132,3.63132,0,1,1-1.66534,7.06912Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.92544,541.47937,504.06073,527.4158a3.63131,3.63131,0,0,1,1.67919-7.06584l.00838.002L564.613,534.41558a3.63129,3.63129,0,0,1-1.68765,7.06374Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.06386,
    cy: 345.5446,
    r: 15.14099,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.1386,574.74359a9.74336,9.74336,0,0,1-2.952-14.54235l-23.38049-42.56507,10.18346-9.36166,27.39972,50.75822a9.72972,9.72972,0,0,1-11.25073,15.71086Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#ffb6b6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.83014,386.32937,421.6833,383.903a8.45373,8.45373,0,0,0-9.26564,8.41466V467.15l46,84.34475,19-12-30-74Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35443,380.25664c5.83076-41.1563,21.89367-77.63684,51.51111-107.92329a9.13979,9.13979,0,0,1,12.17148-4.30657l81.506,38.90226a9.13965,9.13965,0,0,1,4.3065,12.17142l-51.511,107.92336a9.13961,9.13961,0,0,1-12.17136,4.30656l-81.506-38.90226A9.13984,9.13984,0,0,1,645.35443,380.25664Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.36742,392.42786a9.13963,9.13963,0,0,1-4.30656-12.17135c5.83069-41.1565,21.89366-77.637,51.511-107.92342a9.02186,9.02186,0,0,1,3.069-3.54084l-1.60385-.7656a9.14,9.14,0,0,0-12.17148,4.30644c-29.61738,30.28651-45.68028,66.76692-51.511,107.92342a9.1396,9.1396,0,0,0,4.30657,12.17135L731.167,431.33025a9.09907,9.09907,0,0,0,9.10244-.76559Z",
    transform: "translate(-232.41766 -107.85731)",
    opacity: 0.2,
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23935,360.96643l-54.691-25.91774a3.6313,3.6313,0,0,1,3.11008-6.563l54.691,25.91774a3.6313,3.6313,0,0,1-3.11015,6.5629Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.10846,322.75481l-12.032-5.7019a3.63132,3.63132,0,1,1,3.08943-6.57277l.02071.00987,12.032,5.7019a3.63129,3.63129,0,0,1-3.11014,6.5629Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.56641,389.81873l-54.691-25.91774a3.63129,3.63129,0,0,1,3.11014-6.5629l54.691,25.91774a3.63131,3.63131,0,1,1-3.08943,6.57276Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.40285,375.39261l-54.691-25.91774a3.63131,3.63131,0,0,1,3.1023-6.56669l.00778.00372,54.691,25.91775a3.63129,3.63129,0,0,1-3.11014,6.56289Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.00026,
    cy: 178.78672,
    r: 15.14099,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.07666,433.57385c-16.42084-35.62276-23.61165-74.01453-18.57537-116.07437-.7781-4.89295,1.94935-9.79626,6.09693-10.96083l74.34318-20.77016c4.14933-1.15345,8.1455,1.87143,8.933,6.76177l18.57545,116.07437c.7781,4.893-1.94928,9.79627-6.09684,10.96075l-74.34318,20.77017C882.86046,441.489,878.8642,438.4642,878.07666,433.57385Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.24685,433.637c-4.14933,1.15344-8.14544-1.87133-8.933-6.76168-16.421-35.62287-23.61172-74.01463-18.57553-116.07439a10.72776,10.72776,0,0,1,.32275-4.671l-1.46295.40864c-4.14749,1.16458-6.87493,6.0678-6.097,10.96073-5.0362,42.05984,2.15454,80.45152,18.57552,116.07439.78746,4.89034,4.78365,7.91512,8.933,6.76168l74.34315-20.77a8.8344,8.8344,0,0,0,5.77425-6.28968Z",
    transform: "translate(-232.41766 -107.85731)",
    opacity: 0.2,
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.0804,354.21777,888.28767,368.2991c-1.65036.46429-3.2429-.73666-3.55708-2.68263a3.85819,3.85819,0,0,1,2.41235-4.362l49.79274-14.08133c1.65095-.46048,3.24134.74447,3.55223,2.69123a3.85872,3.85872,0,0,1-2.40758,4.3534Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.10336,345.88453,885.149,348.98239c-1.649.47276-3.24623-.71986-3.56753-2.66367a3.8617,3.8617,0,0,1,2.404-4.37567l.01889-.00529,10.95436-3.09786c1.651-.46048,3.24134.74447,3.55223,2.69123A3.85871,3.85871,0,0,1,896.10336,345.88453Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.11266,385.18782l-49.79274,14.08134c-1.651.46048-3.24134-.74448-3.55223-2.69123a3.85871,3.85871,0,0,1,2.40759-4.3534L941.968,378.14319c1.649-.47276,3.24623.71985,3.56754,2.66367a3.8617,3.8617,0,0,1-2.404,4.37566Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.59652,369.70284l-49.79273,14.08134c-1.64963.46894-3.2447-.72749-3.56278-2.67219a3.85923,3.85923,0,0,1,2.411-4.37048l.0071-.002L939.4518,362.6582c1.65095-.46048,3.24134.74447,3.55223,2.69123a3.85872,3.85872,0,0,1-2.40758,4.3534Z",
    transform: "translate(-232.41766 -107.85731)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 900.75374,
    cy: 296.98982,
    rx: 15.14099,
    ry: 12.63838,
    transform: "translate(258.37038 1044.40346) rotate(-82.63777)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.1d4c2187145b4d46187e584c878ac5b2.svg";
export { ForwardRef as ReactComponent };